import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

const badge = (status) => {
  if (status === "completed") return <span className="status-completed dec-pill px-2 py-0.5 text-xs">Terminée</span>;
  if (status === "in_progress") return <span className="status-inprogress dec-pill px-2 py-0.5 text-xs">En cours</span>;
  return <span className="status-notstarted dec-pill px-2 py-0.5 text-xs">À faire</span>;
};

export default function LearnerSessions() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/learner/sessions").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="lg:ml-56">
      <h1 className="font-serif-accent text-3xl sm:text-4xl">Mes séances</h1>
      <p className="text-[#5C6561] mt-1 mb-6 text-sm">Toutes vos séances du programme.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {items.map(s => (
          <Link key={s.id} to={`/learner/seances/${s.id}`} className="dec-card p-4 hover:border-[#D95D39]" data-testid={`learner-session-${s.number}`}>
            <div className="flex items-center justify-between">
              <div className="text-xs text-[#5C6561]">Séance {s.number}</div>
              {badge(s.status)}
            </div>
            <div className="mt-1 font-semibold truncate">{s.title}</div>
            {s.course_date && <div className="text-xs text-[#5C6561] mt-1">📅 {s.course_date}</div>}
          </Link>
        ))}
      </div>
    </div>
  );
}
